module.exports = __webpack_public_path__ + "img/excel.9ccb04cb.svg";